/*
 * EnviAir — Quick view
 *
 * Fetches /products/<handle>?section_id=enviair-quickview and shows it in a
 * native <dialog>, so focus trapping, Escape and the backdrop come from the
 * platform rather than hand-rolled JS.
 */
(function () {
  var SECTION_ID = 'enviair-quickview';
  var dialog = null;
  var body = null;
  var opener = null;

  function build() {
    if (dialog) return dialog;

    dialog = document.createElement('dialog');
    dialog.className = 'ea-qv-dialog';
    dialog.setAttribute('aria-label', 'Quick view');
    dialog.innerHTML =
      '<button class="ea-qv-dialog__close" type="button" aria-label="Close">&times;</button>' +
      '<div class="ea-qv-dialog__body" data-qv-body>' +
      '<p class="ea-qv-dialog__status">Loading&hellip;</p>' +
      '</div>';

    document.body.appendChild(dialog);
    body = dialog.querySelector('[data-qv-body]');

    dialog.querySelector('.ea-qv-dialog__close').addEventListener('click', close);

    // Click on the backdrop — outside the dialog's own box — closes it.
    dialog.addEventListener('click', function (event) {
      if (event.target !== dialog) return;
      var r = dialog.getBoundingClientRect();
      var outside =
        event.clientX < r.left || event.clientX > r.right ||
        event.clientY < r.top || event.clientY > r.bottom;
      if (outside) close();
    });

    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('ea-qv-open');
      if (opener && document.contains(opener)) opener.focus();
      opener = null;
    });

    return dialog;
  }

  function close() {
    if (dialog && dialog.open) dialog.close();
  }

  function open(url, trigger) {
    var el = build();
    opener = trigger || null;

    body.innerHTML = '<p class="ea-qv-dialog__status">Loading&hellip;</p>';
    document.documentElement.classList.add('ea-qv-open');

    if (typeof el.showModal === 'function') {
      el.showModal();
    } else {
      el.setAttribute('open', '');
    }

    var sep = url.indexOf('?') === -1 ? '?' : '&';

    fetch(url + sep + 'section_id=' + SECTION_ID)
      .then(function (response) {
        if (!response.ok) throw new Error('HTTP ' + response.status);
        return response.text();
      })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var content = parsed.querySelector('[data-ea-qv-root]');

        if (!content) throw new Error('Quick view markup missing');

        body.innerHTML = '';
        body.appendChild(content);
        bindVariants(body);
        bindThumbs(body);

        // The tabs script ran at page load, long before this markup existed,
        // so the injected panels have to be wired up explicitly.
        if (window.EnviAirTabs) window.EnviAirTabs.init(body);

        var focusable = body.querySelector('select, button, a');
        if (focusable) focusable.focus();
      })
      .catch(function () {
        // Never strand the visitor in a broken modal — offer the real page.
        body.innerHTML =
          '<p class="ea-qv-dialog__status">Quick view is unavailable. ' +
          '<a href="' + url + '">Open the full product page</a>.</p>';
      });
  }

  // Keep the displayed price in step with the chosen variant.
  function bindVariants(scope) {
    var select = scope.querySelector('[data-ea-qv-variants]');
    var price = scope.querySelector('[data-ea-qv-price]');
    if (!select || !price) return;

    select.addEventListener('change', function () {
      var option = select.options[select.selectedIndex];
      var formatted = option && option.dataset.price;
      if (formatted) price.textContent = formatted;
    });
  }

  // Thumbnails swap the stage image rather than opening a new view, so the
  // modal keeps its height and the buy controls never move.
  function bindThumbs(scope) {
    var thumbs = scope.querySelector('[data-ea-qv-thumbs]');
    var stage = scope.querySelector('.ea-qv__image');
    if (!thumbs || !stage) return;

    thumbs.addEventListener('click', function (event) {
      var button = event.target.closest('.ea-qv__thumb');
      if (!button) return;

      var full = button.getAttribute('data-full');
      if (!full) return;

      stage.src = full;
      stage.srcset = '';
      stage.alt = button.getAttribute('data-alt') || '';

      thumbs.querySelectorAll('.ea-qv__thumb').forEach(function (other) {
        other.setAttribute('aria-pressed', other === button ? 'true' : 'false');
      });
    });
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-ea-quickview]');
    if (!trigger) return;

    var url = trigger.getAttribute('data-product-url');
    if (!url) return;

    event.preventDefault();
    open(url, trigger);
  });
})();
